import errorWrapper from '~/redux/reducers/utils/errorWrapper';
import { feInitialState, feState } from './fe';
export const initialState = Object.assign({}, feInitialState());
const appState = (state = initialState, action) => {
    return feState(state, action);
};
export default errorWrapper(appState);
